import '../input/number-input';
import '../input/button-input';

import { html, LitElement } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { NumberInput } from '../input/number-input';
import { cartStore } from '../../_stores/cart-store';
import { ButtonInput } from '../input/button-input';

@customElement('line-item')
export class LineItem extends LitElement {

    // Props

    @property({ type: String })
    id: string = '';

    @property({ type: String })
    description: string = '';

    @property({ type: String })
    total: string = '';

    @property({ type: Number })
    qty: number = 0;

    @property({ type: String })
    productUrl: string = '';

    @property({ type: Number })
    productId?: number = undefined;

    @property({ type: String })
    thumbnail?: string = undefined;

    @state()
    private _busy: boolean = false;

    @query('number-input')
    _numberInput!: NumberInput;

    @query('button-input')
    _buttonInput!: ButtonInput;


    // Lifecycle Hooks

    connectedCallback() {
        super.connectedCallback();
        this.classList.add('LineItem');
    }

    async firstUpdated() {
        const thumbnailQuery = `
            query {
                products(id: ${ this.productId }) {
                    ... on general_Product {
                        metaThumbnail {
                            url @transform (width: 300)
                        }
                    }
                }
            }
        `;
        const response = await fetch('/api', {
            method: 'post',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ query: thumbnailQuery }),
        });
        const data = await response.json();
        const thumbnailUrl = data.data?.products[0]?.metaThumbnail[0]?.url;
        if (thumbnailUrl) this.thumbnail = thumbnailUrl;
    }

    // Render

    render() {
        return html`
            <div class="LineItem-block LineItem-block--thumbnail">
                ${ this.thumbnail ? html`<img class="LineItem-thumbnail" src="${ this.thumbnail }" />` : '' }
            </div>
            <div class="LineItem-block LineItem-block--info">
                <div class="LineItem-description">
                    <a href="${ this.productUrl }" class="LineItem-link">
                        ${ this.description }
                    </a>
                </div>
                <div class="LineItem-qtyAdjust">
                    <number-input 
                        value="${ this.qty }"
                        .disabled="${ this._busy }"
                        @change="${ this._updateValue }">
                    </number-input>
                    <button-input
                        name="remove"
                        .disabled="${ this._busy }"
                        @click="${ this._remove }">
                        <div slot="label">
                            Remove
                        </div>
                    </button-input>
                </div>
            </div>
            <div class="LineItem-block LineItem-block--total">
                <div class="LineItem-total">
                    ${ this.total }
                </div>
            </div>
        `;
    }

    createRenderRoot() { 
        return this;
    }

    // Methods

    private async _updateValue(e: Event) {
        this._busy = true;
        const input = e.target as NumberInput;
        this.qty = input.value;
        await cartStore.updateLineItem(this);
        this._busy = false;
    }

    private async _remove() {
        this._busy = true;
        this.qty = 0;
        await cartStore.updateLineItem(this);
    }

}